@import '~style-sheet-helpers/core.less';

.summary-bar {
  margin: 20px auto;
}

.container {
  display: flex;
}

.chart-section {
  width: 100%;
  margin: 20px;
}

.items-sold-over-time-graph {
  margin-top: 20px;
  position: relative;
}

.top-five-charts {
  padding-bottom: 20px;
  margin: 0 20px;
}
